import React from "react";
import { Box, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

const sx = {
  inEffect: {
    color: "acqua.c110"
  },
  pending: {
    color: "common.pending"
  },
  status: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textTransform: "uppercase",
    gap: "8px",
    marginLeft: "24px",
    span: {
      color: "blue.c100"
    }
  }
};

const ApprovalStatus = ({ data = {} }) => {
  const confirmedStatus = (
    <>
      <CircleIcon sx={sx.inEffect} fontSize="small" />
      <Typography variant="overline1">{`In Effect - CONFIRMED ON ${new Date(data.approvedOn).toLocaleDateString(
        "en-US",
        { year: "numeric", month: "2-digit", day: "2-digit" }
      )}`}</Typography>
    </>
  );
  const pendingStatus = (
    <>
      <CircleIcon sx={sx.pending} fontSize="small" />
      <Typography variant="overline1">PENDING</Typography>
    </>
  );
  return (
    data.approvalStatus && (
      <Box sx={sx.status}>{data.approvalStatus === "A" ? data.approvedOn && confirmedStatus : pendingStatus}</Box>
    )
  );
};

export default ApprovalStatus;
